import renderApproveRentingModal from "../../../infrastructure/renders/ApproveRentingModal/render-approve-renting-modal";
import adaptRentingApprovalCalculationsPayload from "../../../infrastructure/adapters/rentingRequests/adaptRentingApprovalCalculationsPayload";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import {
  approveRequest,
  reviewRequestDetails,
} from "../../../infrastructure/repository/request-repository";
import { hideModal } from "../../commons/hide-modal";
import renderRentingResultsModal from "../../../infrastructure/renders/RentingResultsModal/render-renting-results-modal";
import { displayRequestsPage } from "../display-requests-page";
import { showSuccessMessage } from "../../commons/show-success-message";
import { translate } from "../../../infrastructure/translate/localization";
import { showErrorMessage } from "../../commons/show-error-message";

export default async function approveRentingRequest({ requestId }) {
  const companyId = await findCompanyId();

  const callback = async (payload) => {
    renderApproveRentingModal({ defaultValues: payload, isLoading: true });
    try {
      const { data } = await reviewRequestDetails({
        companyId,
        category: "renting-benefit",
        requestId,
        payload: adaptRentingApprovalCalculationsPayload(payload),
      });
      renderRentingResultsModal({
        callback: async () => {
          renderRentingResultsModal({ isLoading: true, ...data });
          await approveRequest({
            companyId,
            category: "renting-benefit",
            requestId,
            payload: adaptRentingApprovalCalculationsPayload(payload),
          });
          hideModal();
          showSuccessMessage(
            translate("employees-section.renting-request-approved-successfully")
          );
          displayRequestsPage({ selectedTab: "renting" });
        },
        ...data,
        payload,
        previousCallback: callback,
      });
    } catch (err) {
      hideModal();
      showErrorMessage(translate("common-messages.basic-error-message"));
    }
  };

  const action = () => {
    renderApproveRentingModal({
      callback,
    });
  };
  action();
}
